// extracted by mini-css-extract-plugin
module.exports = {"detail_new":"styles_detail_new__1PhYi","header":"styles_header__3_1QQ","back":"styles_back__13Ra3","title":"styles_title__RNo-8","content":"styles_content__4eBlO"};